import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditPermissionComponent } from '@app/core/windows'; 


@Component({
  selector: 'permissions-crud',
  templateUrl: './permissions-crud.component.html',
  providers: [ DatasourceService ]
})
export class PermissionsCrudComponent extends BaseCrudComponent implements OnInit {

  @ViewChild(CreateEditPermissionComponent, {static: false}) window !: CreateEditPermissionComponent;

  protected menu: string = 'Acceso';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Permiso';

  protected name: string = 'Permisos';

  protected table: string = 'permissions';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}